import { LABELS } from '@/constants/common/message.constants'

import { type TruckSpecificationEntity } from '../..'

/**
 * 車型
 */
export type TruckBodyType = Exclude<TruckSpecificationEntity['type'], null>

export const TRUCK_BODY_TYPE = {
  /** ウイング */
  WING: 'WING',
  /** バン */
  VAN: 'VAN',
  /** 平ボディ */
  FLAT: 'FLAT',
  /** クレーン */
  CRANE: 'CRANE',
  /** トレーラーヘッド */
  TRAILER_HEAD: 'TRAILER_HEAD',
  /** トレーラーシャーシ */
  TRAILER_CHASSIS: 'TRAILER_CHASSIS',
  /** セルフローダー */
  SELF_LOADER: 'SELF_LOADER',
  /** トラック */
  LORRY: 'LORRY',
  /** バルク */
  BULK: 'BULK',
  /** タンク */
  TANK: 'TANK',
  /** ミキサー */
  MIXER: 'MIXER',
  /** キャリアカー */
  CAR_CARRIER: 'CAR_CARRIER',
  /** 幌 */
  TARPAULIN: 'TARPAULIN',
  /** アコーディオン */
  ACCORDION_COVER: 'ACCORDION_COVER',
  /** オープントップ */
  OPEN_TOP: 'OPEN_TOP',
  /** 鮮魚車 */
  FRESH_FISH_TRUCK: 'FRESH_FISH_TRUCK',
  /** 家畜輸送車 */
  LIVESTOCK_TRUCK: 'LIVESTOCK_TRUCK'
} as const satisfies Record<TruckBodyType, TruckBodyType>

export const TRUCK_BODY_TYPE_LABEL = {
  [TRUCK_BODY_TYPE.WING]: LABELS.WING,
  [TRUCK_BODY_TYPE.VAN]: LABELS.VAN,
  [TRUCK_BODY_TYPE.FLAT]: LABELS.FLAT,
  [TRUCK_BODY_TYPE.CRANE]: LABELS.CRANE,
  [TRUCK_BODY_TYPE.TRAILER_HEAD]: LABELS.TRAILER_HEAD,
  [TRUCK_BODY_TYPE.TRAILER_CHASSIS]: LABELS.TRAILER_CHASSIS,
  [TRUCK_BODY_TYPE.SELF_LOADER]: LABELS.SELF_LOADER,
  [TRUCK_BODY_TYPE.LORRY]: LABELS.LORRY,
  [TRUCK_BODY_TYPE.BULK]: LABELS.BULK,
  [TRUCK_BODY_TYPE.TANK]: LABELS.TANK,
  [TRUCK_BODY_TYPE.MIXER]: LABELS.MIXER,
  [TRUCK_BODY_TYPE.CAR_CARRIER]: LABELS.CAR_CARRIER,
  [TRUCK_BODY_TYPE.TARPAULIN]: LABELS.TARPAULIN,
  [TRUCK_BODY_TYPE.ACCORDION_COVER]: LABELS.ACCORDION_COVER,
  [TRUCK_BODY_TYPE.OPEN_TOP]: LABELS.OPEN_TOP,
  [TRUCK_BODY_TYPE.FRESH_FISH_TRUCK]: LABELS.FRESH_FISH_TRUCK,
  [TRUCK_BODY_TYPE.LIVESTOCK_TRUCK]: LABELS.LIVESTOCK_TRUCK
} as const satisfies Record<TruckBodyType, string>
